export default function FormSection({ title, infos, children, action }) {
    return (
        <div className="rounded border flex flex-col md:flex-row space-x-0 md:space-x-6 space-y-3 md:space-y-0">
            <div className="w-full p-3 flex flex-col space-y-3">
                <div className="flex justify-between items-center">
                    <p className='tracking-tight font-bold'>
                        {title}
                    </p>
                    <div>
                        {action}
                    </div>
                </div>
                {children}
            </div>
            <div className="w-full bg-gray-50 p-3 border-l">
                {infos}
            </div>
        </div>
    )
}
